import { __exports as config } from "../../../../../../_virtual/config.js";
import { __require as requireLogger } from "../util/logger.js";
import { __require as requireLoglevel } from "./loglevel.js";
var hasRequiredConfig;
function requireConfig() {
  if (hasRequiredConfig) return config;
  hasRequiredConfig = 1;
  Object.defineProperty(config, "__esModule", { value: true });
  config.EU_SERVER_URLS = config.CohortSyncConfigDefaults = config.AssignmentConfigDefaults = config.LocalEvaluationDefaults = config.Defaults = config.RemoteEvaluationDefaults = void 0;
  const logger_1 = requireLogger();
  const loglevel_1 = requireLoglevel();
  config.RemoteEvaluationDefaults = {
    debug: false,
    logLevel: loglevel_1.LogLevel.Error,
    loggerProvider: new logger_1.ConsoleLogger(),
    instanceName: void 0,
    serverZone: "us",
    serverUrl: "https://api.lab.amplitude.com",
    fetchTimeoutMillis: 1e4,
    fetchRetries: 8,
    fetchRetryBackoffMinMillis: 500,
    fetchRetryBackoffMaxMillis: 1e4,
    fetchRetryBackoffScalar: 1.5,
    fetchRetryTimeoutMillis: 1e4,
    httpAgent: null
  };
  config.Defaults = {
    debug: false,
    logLevel: loglevel_1.LogLevel.Error,
    loggerProvider: new logger_1.ConsoleLogger(),
    instanceName: void 0,
    serverZone: "us",
    serverUrl: "https://api.lab.amplitude.com",
    fetchTimeoutMillis: 1e4,
    fetchRetries: 8,
    fetchRetryBackoffMinMillis: 500,
    fetchRetryBackoffMaxMillis: 1e4,
    fetchRetryBackoffScalar: 1.5,
    fetchRetryTimeoutMillis: 1e4,
    httpAgent: null
  };
  config.LocalEvaluationDefaults = {
    debug: false,
    logLevel: loglevel_1.LogLevel.Error,
    loggerProvider: new logger_1.ConsoleLogger(),
    serverZone: "us",
    serverUrl: "https://api.lab.amplitude.com",
    bootstrap: {},
    flagConfigPollingIntervalMillis: 3e4,
    httpAgent: null,
    streamUpdates: false,
    streamServerUrl: "https://stream.lab.amplitude.com",
    streamFlagConnTimeoutMillis: 1500
  };
  config.AssignmentConfigDefaults = {
    cacheCapacity: 65536
  };
  config.CohortSyncConfigDefaults = {
    cohortServerUrl: "https://cohort-v2.lab.amplitude.com",
    maxCohortSize: 2147483647,
    cohortPollingIntervalMillis: 6e4
  };
  config.EU_SERVER_URLS = {
    name: "eu",
    remote: "https://api.lab.eu.amplitude.com",
    flags: "https://flag.lab.eu.amplitude.com",
    stream: "https://stream.lab.eu.amplitude.com",
    cohort: "https://cohort-v2.lab.eu.amplitude.com"
  };
  return config;
}
export {
  requireConfig as __require
};
//# sourceMappingURL=config.js.map
